import React, {useEffect, useRef, useState, useContext} from 'react';
import firebase from 'firebase';

import * as dataManager from '../adapters/data';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';
import { GlobalContext } from '../contexts/GlobalContext';


const EditQualificationModal = (props) => {

    const modalRef = useRef(null);

    const [edit, setEdit] = useState(true);

    const [context, setContext] = useContext(GlobalContext);

    const [name, setName] = useState(context['editPositionModal']? context['editPositionModal'].name : '');
    const [description, setDescription] = useState(context['editQualificationModal']? context['editQualificationModal'].description : '');
    const [employees, setEmployees] = useState([]);

    const [modified, setModified] = useState(false);

    useEffect( () => {
        if (props.show) {
            modalRef.current.focus();
        }

        setEmployees(props.employees.map( (e) => (JSON.stringify({id: e.id, name: e.name, qualifications: e.qualifications}))));
        setModified(false);

    }, [props.show]
    );

    const editQualification = () => {

            console.log(context['editQualificationModal'].id);
            console.log('Qualification Edited - ' + context['editQualificationModal'].id);
            props.onClose();

            dataManager.editQualification(context['editQualificationModal'].id,
                context['editQualificationModal'].name, 
                context['editQualificationModal'].description
            );

            context['employees'].map( (e) => {
                let arr = e.qualifications.filter( q => q.name != context['editQualificationModal'].name && q.id != context['editQualificationModal'].id);
                if (employees.find( f => JSON.parse(f).name === e.name) === undefined) {
                    dataManager.editEmployee(e.id, e.name, arr);
                }
                else
                    dataManager.editEmployee(e.id, e.name, [...arr, {id: context['editQualificationModal'].id, name: context['editQualificationModal'].name} ]);
            });

            context['positions'].map( (e) => {
                let arr = e.qualifications.filter( q => q.name != context['editQualificationModal'].name && q.id != context['editQualificationModal'].id);

                dataManager.editPosition(e.id, e.name, [...arr, {id: context['editQualificationModal'].id, name: context['editQualificationModal'].name} ]);
            });

            setModified(false);
            props.onEdit();
    }

    const updateName = (e) => {
        // setName(e.target.value);

        let editQualificationModal = context['editQualificationModal'];
        editQualificationModal.name = e.target.value;

        setContext( (prevState) => {
            return {
                ...prevState, 
                editQualificationModal: editQualificationModal
            }
        });
    }
    
    const updateDescription = (e) => {
        setDescription(e.target.value);
        console.log(e.target.value);

        let editQualificationModal = context['editQualificationModal'];
        editQualificationModal.description = e.target.value;

        setContext( (prevState) => {
            return {
                ...prevState, 
                editQualificationModal: editQualificationModal
            }
        });
    }

    const updateEmployees = (e, data) => {
        setEmployees(data.value);   
        setModified(true);
    }

    const cancelClose = () => {
        setName(context['editQualificationnModal'] ? context['editQualificationnModal'].name : '');
        setDescription(context['editQualificationnModal'] ? context['editQualificationModal'].description : '');
        props.onClose();
    }   
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show} role={`Edit ${props.name} dialog`}
            >
            <Modal.Header>Edit Qualification</Modal.Header>
            <Modal.Content>
            {
                props.name? <Input ref={modalRef} style={{marginRight: 10}} placeholder='Name' onChange={updateName} defaultValue={props.name}  /> :
                <Input ref={modalRef} style={{marginRight: 10}} placeholder='Name' onChange={updateName} />
            }

            {
                props.description ? <Input placeholder='Description' onChange={updateDescription} defaultValue={props.description} />
                : <Input placeholder='Description' onChange={updateDescription} />
            }

            <br /><br />

            Employees with Qualification
            <br /><br />
            <div style={{display: 'flex'}}>
                <Dropdown
                    fluid
                    multiple
                    search
                    selection
                    placeholder='Select the employees you wish to have this qualification'
                    options={ context['employees'] ? context['employees'].map( (q) => ({key: q.id, text: q.name, value:  JSON.stringify({id: q.id, name: q.name, qualifications: q.qualifications})} )) : []}
                    // defaultValue= { context['employees'] ? context['employees']
                    //     .map( (q) => ({key: q.name, text: q.name, value: q.name} ))
                    //     .filter() : [] }

                    // defaultValue={props.employees.map( (e) => (JSON.stringify({id: e.id, name: e.name, qualifications: e.qualifications})))}
                    value={modified === false ? props.employees.map( (e) => (JSON.stringify({id: e.id, name: e.name, qualifications: e.qualifications}))) : employees}

                    onChange={updateEmployees}
                        
                    
                    // options={context['qualifications'] ? context['qualifications'].map( (q) => ({key: q.name, text: q.name, value: q.name} )) : []}
                /><div>
                <Button basic onClick={ () => {
                    setModified(true);
                    setEmployees( context['employees'] ? context['employees'].map( (q) => (JSON.stringify({id: q.id, name: q.name, qualifications: q.qualifications}) )) : [] )
                }} >
                Select All
                </Button>
                <Button basic onClick={ () => {
                    setModified(true);
                    setEmployees( [] );
                }} >
                Clear All
                </Button></div>
            </div>
                
            </Modal.Content>
            <Modal.Actions style={{display: 'flex', justifyContent: 'space-between'}}>
                <Button basic onClick={props.confirmDeleteCallback('qualification', 'Delete Qualification', ' qualification?',context['editQualificationModal'] ? context['editQualificationModal'].name : '', context['editQualificationModal'] ? context['editQualificationModal'].id : '')}>Delete</Button>
                <div>
                    <Button basic onClick={cancelClose} >
                    Cancel
                    </Button>
                    <Button color='blue' disabled={context['editQualificationModal']?.name.trim() == ''? true : false} onClick={editQualification} >
                    Save
                    </Button>
                </div>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default EditQualificationModal;